import { lazy } from "react";

const CommonLayout = lazy(() => import("../layouts/CommonLayout.jsx"));

const HomeView = lazy(() => import("../views/search/SearchHomeView.jsx"));
const DisplayHomeView = lazy(() => import("../views/display/DisplayHomeView.jsx"));

const PageNotFoundView = lazy(() => import("../views/error/PageNotFoundView.jsx"));

const ThemeRoutes = [
     {
        path: "/",
        element: <CommonLayout />,
        children: [
            { path: "", exact: true, element: <HomeView /> },
            { path: "/display/*", exact: true, element: <DisplayHomeView /> }
        ],

    },
    {
    path: "*",
    element: <PageNotFoundView />,
  }
]
export default ThemeRoutes;